<template>
  <div>
    <Row style="padding-left:6px; margin-top: 6px;">
      <Input size="small" v-model="searchVehicleListDataKeyword" placeholder="名称..." style="width: 100%;"
             clearable/>
    </Row>
    <Row style="padding-left:6px;margin-top:3px;margin-bottom:3px;">
      <div style="width: 33%; display: inline-block; padding-right: 1px;">
        <Button size="small" style="width: 100%;" @click="onSelectAllClick">全选</Button>
      </div>
      <div style="width: 33%; display: inline-block; padding-right: 1px;">
        <Button size="small" style="width: 100%;" @click="onUnSelectAllClick">反选
        </Button>
      </div>
      <div style="width: 33%; display: inline-block;">
        <Button style="width: 100%;" size="small" type="success"
                @click="onLoadVehicleDymaicClick">加载
        </Button>
      </div>
    </Row>
    <div style="position:relative; margin-left: 6px;">
      <div
          :style="{height: vehicleListTableHeightCompute + 'px', backgroundColor:'#FFFFFF', display:'block', overflow:'scroll', width:'300px'}">
        <Row style="margin-top: 1px; margin-left: 5px;" v-for="item in vehicleListDataCompute">
          <Checkbox style="display: inline-block;" v-model="item.customChecked"></Checkbox>
          <div @click="onSingleLoadVehicleDymaicClick(item)" v-if="item.registrationNum"
               :style="{display: 'inline-block', width:'fit-content', paddingLeft:'2px', paddingRight:'2px', 'border-radius': '3px', backgroundColor:registrationColorCompute(item.registrationColor)}">
            {{item.displayName}}
          </div>
          <div v-if="!item.registrationNum" style="display:inline-block;"
               @click="onSingleLoadVehicleDymaicClick(item)">{{item.displayName}}
          </div>
          <div style="display:inline-block; margin-left: 5px;"
               @click="onQueryTripsClick(item.registrationNum==null?item.vin:item.registrationNum)">
            <Icon type="md-alarm"/>
          </div>
        </Row>
        <!--</div>-->
      </div>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="vehicleListLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { GPS } from '@/libs/positonUtils'
import Icons from '_c/icons'
import store from '@/store'
import { VehicleDymaicManager } from '@/libs/vehicle-dymaic-manager2'
import jcicp from '@/proto/jcicp.js'
import { jcicpEncode, jcicpDecode } from '@/libs/jcicputil.js'
import { registrationTextColor, registrationColor } from '@/libs/registrationutil'
import { isAccOn, explainDirection, explainState, explainAlarmSign } from '@/libs/jt808util'
import { stringToByte } from '@/libs/stringutil'

// 车辆选择订阅列表由服务器数据生成新实体避免重复引用报错
// DataItem
//        |---registrationNum
//        |---registrationColor
//        |---terminalNum
//        |---id
//        |---vin
//        |---customName
//        |---customChecked

export default {
  name: 'vehicleinfolist',
  components: {
    Icons
  },
  props: {
    vehicleListData: {
      require: true
    },
    vehicleListLoadding: {
      require: true
    },
    vehicleListTableHeight: {
      require: true
    }
  },
  data () {
    return {
      // 选择订阅车辆列表
      readySubscribeList: [],
      searchVehicleListDataKeyword: null // 订阅树搜索车辆名称关键字
    }
  },
  methods: {
    /** --------------------------------------------------
       * 方法部分
       */

    /**
       * 反选
       */
    onUnSelectAllClick () {
      let items = this.vehicleListDataMethod()
      if (!items) {
        return
      }
      items.forEach(item => {
        item.customChecked = false
      })
    },

    /**
       * 全选
       */
    onSelectAllClick () {
      let items = this.vehicleListDataMethod()
      if (!items) {
        return
      }
      items.forEach(item => {
        item.customChecked = true
      })
    },

    /**
       * 加载按钮回调函数
       */
    onLoadVehicleDymaicClick () {
      if (!this.vehicleListData) {
        return
      }
      let selectItems = this.vehicleListData.filter(item => item.customChecked)
      if (!selectItems) {
        return
      }
      this.$emit('onLoadVehicleDymaicClick', selectItems)
    },

    /**
       * 加载单台按钮回调函数
       */
    onSingleLoadVehicleDymaicClick (item) {
      this.$emit('onSingleLoadVehicleDymaicClick', item)
      item.customChecked = true
    },

    /**
       * 封装车牌颜色底色方法
       */
    registrationColorCompute (val) {
      return registrationColor(val)
    },

    /**
       * 封装车牌颜色文字颜色方法
       */
    registrationTextColorCompute (val) {
      return registrationTextColor(val)
    },

    /**
       * 筛选关键字列表
       */
    vehicleListDataMethod () {
      if (this.vehicleListData) {
        if (this.searchVehicleListDataKeyword && this.searchVehicleListDataKeyword !== '') {
          return this.vehicleListData.filter(item => {
            if (item.customName) {
              if (item.customName.toLocaleUpperCase().indexOf(this.searchVehicleListDataKeyword.toLocaleUpperCase()) >= 0) {
                return true
              }
            }
            let name = null
            if (item.registrationNum) {
              name = item.registrationNum
            } else {
              name = item.vin
            }
            if (name.toLocaleUpperCase().indexOf(this.searchVehicleListDataKeyword.toLocaleUpperCase()) >= 0) {
              return true
            } else {
              return false
            }
          })
        } else {
          return this.vehicleListData
        }
      } else {
        return []
      }
    }
  },
  computed: {
    vehicleListTableHeightCompute () {
      if (this.vehicleListTableHeight) {
        return this.vehicleListTableHeight
      } else {
        return 600
      }
    },
    vehicleListDataCompute () {
      return this.vehicleListDataMethod()
    }
  },
  beforeDestroy () {

  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
